import type { PartnerCockpitNotification } from '@houzy/schemas/partner-cockpit/notifications';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import { useMemo, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { formatDayLabel } from '../../../lib/time';
import { groupNotificationsByDay } from '../utils/groupNotificationsByDay';
import { NotificationItem } from './NotificationItem';

export type NotificationsListProps = {
    notifications: PartnerCockpitNotification[];
    onSelect: (notification: PartnerCockpitNotification) => void;
    onMarkAsRead: (notification: PartnerCockpitNotification) => void;
};

export function NotificationsList({ notifications, onSelect, onMarkAsRead }: NotificationsListProps): ReactElement {
    const { t, i18n } = useTranslation();
    const groups = useMemo(() => groupNotificationsByDay(notifications), [notifications]);

    return (
        <List disablePadding subheader={<li />}>
            {groups.map((group) => (
                <li key={group.day}>
                    <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                        <ListSubheader sx={{ bgcolor: 'background.default', textTransform: 'uppercase' }}>
                            {formatDayLabel(group.day, t, i18n.language)}
                        </ListSubheader>
                        {group.notifications.map((notification) => (
                            <NotificationItem
                                key={notification.uuid}
                                notification={notification}
                                onSelect={onSelect}
                                onMarkAsRead={onMarkAsRead}
                            />
                        ))}
                    </ul>
                </li>
            ))}
        </List>
    );
}
